export default function setCorrectLinks(regions, domain) {
  return regions.map(function (region) {
    return {
      name: region.name,
      link: domain + '/anbieter/immobilienmakler' + region.link
    };
  });
}